<script setup lang="ts">
import type {
  NovaModalNoticeCreatePreviewEmits,
  NovaModalNoticeCreatePreviewProps,
} from './NovaModalNoticeCreatePreview.types'

defineEmits<NovaModalNoticeCreatePreviewEmits>()
defineProps<NovaModalNoticeCreatePreviewProps>()
</script>

<template>
  <div class="preview-wrap">
    <h4 class="post-title">{{ title }}</h4>
    <div class="preview-box">
      <NovaBoxPostContentsSnapshotContents
        :contents="contents"
        :show-gradiant="false"
        :view-type="'detail'"
        class="post-contents"
      />
    </div>
    <div class="action-box">
      <NovaButtonText
        :label="$t('postCreate.button.confirm')"
        :theme="'secondary-gray'"
        :size="32"
        class="btn-action"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.preview-wrap {
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;

  .post-title {
    flex-shrink: 0;
    @include text-style($text-heading2-bold);
    color: $color-text-2;
    @include ellipsis(2);
  }
  .preview-box {
    height: 100%;
    overflow-y: overlay;
  }

  .post-contents {
    flex-grow: 1;
  }
  .action-box {
    text-align: right;
  }
}
</style>
